import { selectCartItems } from '@/app/modules/cart/state/common/entities/cart-item/cart-item.selectors';
import { State } from '@/app/state/model';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Location } from '@egovsolutions/angular-location';
import { Viewport } from '@egovsolutions/angular-viewport';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-cart-state-bar-space-taker',
    template: `
        <div class="taker"
            *ngIf="viewport.phone$ | async"
            [class.empty]="!(itemCount$ | async)"
            [class.in-cart]="(location.url$ | async) === '/cart'"
        ></div>`,
    styleUrls: ['./space-taker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpaceTakerComponent
{
    constructor
    (
        // Dependencies

        private readonly store: Store<State>,


        // Template dependencies

        protected readonly viewport: Viewport,
        protected readonly location: Location,
    )
    {}

    protected readonly itemCount$ = this.store.select(selectCartItems).pipe(
        map(items => items?.length),
    );
}
